/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const imminer = $root.imminer = (() => {

    /**
     * Namespace imminer.
     * @exports imminer
     * @namespace
     */
    const imminer = {};

    imminer.msggateway = (function() {

        /**
         * Namespace msggateway.
         * @memberof imminer
         * @namespace
         */
        const msggateway = {};

        /**
         * MsgType enum.
         * @name imminer.msggateway.MsgType
         * @enum {number}
         * @property {number} JoinServer=0 JoinServer value
         * @property {number} TextMsgType=1 TextMsgType value
         * @property {number} CreateSessionMsgType=4 CreateSessionMsgType value
         * @property {number} AgentUserJoinSessionMsgType=5 AgentUserJoinSessionMsgType value
         * @property {number} HasReadReceiptMsgType=6 HasReadReceiptMsgType value
         * @property {number} KickOffLineMsgType=7 KickOffLineMsgType value
         * @property {number} EndSessionMsgType=8 EndSessionMsgType value
         */
        msggateway.MsgType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "JoinServer"] = 0;
            values[valuesById[1] = "TextMsgType"] = 1;
            values[valuesById[4] = "CreateSessionMsgType"] = 4;
            values[valuesById[5] = "AgentUserJoinSessionMsgType"] = 5;
            values[valuesById[6] = "HasReadReceiptMsgType"] = 6;
            values[valuesById[7] = "KickOffLineMsgType"] = 7;
            values[valuesById[8] = "EndSessionMsgType"] = 8;
            return values;
        })();

        /**
         * ContentType enum.
         * @name imminer.msggateway.ContentType
         * @enum {number}
         * @property {number} TextContentType=0 TextContentType value
         * @property {number} ImgContentType=1 ImgContentType value
         * @property {number} VideoContentType=2 VideoContentType value
         * @property {number} FaqContentType=3 FaqContentType value
         * @property {number} KnowledgePointContentType=4 KnowledgePointContentType value
         * @property {number} KnowledgeAnswerContentType=5 KnowledgeAnswerContentType value
         * @property {number} SystemContentType=6 SystemContentType value
         * @property {number} CreateSessionContentType=7 CreateSessionContentType value
         * @property {number} AgentUserJoinSessionContentType=8 AgentUserJoinSessionContentType value
         * @property {number} EndSessionContentType=9 EndSessionContentType value
         * @property {number} RankingContentType=10 RankingContentType value
         * @property {number} TransferContentType=11 TransferContentType value
         * @property {number} UnsupportedContentType=12 UnsupportedContentType value
         */
        msggateway.ContentType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "TextContentType"] = 0;
            values[valuesById[1] = "ImgContentType"] = 1;
            values[valuesById[2] = "VideoContentType"] = 2;
            values[valuesById[3] = "FaqContentType"] = 3;
            values[valuesById[4] = "KnowledgePointContentType"] = 4;
            values[valuesById[5] = "KnowledgeAnswerContentType"] = 5;
            values[valuesById[6] = "SystemContentType"] = 6;
            values[valuesById[7] = "CreateSessionContentType"] = 7;
            values[valuesById[8] = "AgentUserJoinSessionContentType"] = 8;
            values[valuesById[9] = "EndSessionContentType"] = 9;
            values[valuesById[10] = "RankingContentType"] = 10;
            values[valuesById[11] = "TransferContentType"] = 11;
            values[valuesById[12] = "UnsupportedContentType"] = 12;
            return values;
        })();

        msggateway.State = (function() {

            /**
             * Properties of a State.
             * @memberof imminer.msggateway
             * @interface IState
             * @property {number|null} [code] State code
             * @property {string|null} [message] State message
             */

            /**
             * Constructs a new State.
             * @memberof imminer.msggateway
             * @classdesc Represents a State.
             * @implements IState
             * @constructor
             * @param {imminer.msggateway.IState=} [properties] Properties to set
             */
            function State(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * State code.
             * @member {number} code
             * @memberof imminer.msggateway.State
             * @instance
             */
            State.prototype.code = 0;

            /**
             * State message.
             * @member {string} message
             * @memberof imminer.msggateway.State
             * @instance
             */
            State.prototype.message = "";

            /**
             * Creates a new State instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.State
             * @static
             * @param {imminer.msggateway.IState=} [properties] Properties to set
             * @returns {imminer.msggateway.State} State instance
             */
            State.create = function create(properties) {
                return new State(properties);
            };

            /**
             * Encodes the specified State message. Does not implicitly {@link imminer.msggateway.State.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.State
             * @static
             * @param {imminer.msggateway.IState} message State message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            State.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                return writer;
            };

            /**
             * Encodes the specified State message, length delimited. Does not implicitly {@link imminer.msggateway.State.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.State
             * @static
             * @param {imminer.msggateway.IState} message State message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            State.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a State message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.State
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.State} State
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            State.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.State();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.code = reader.int32();
                            break;
                        }
                    case 2: {
                            message.message = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a State message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.State
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.State} State
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            State.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a State message.
             * @function verify
             * @memberof imminer.msggateway.State
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            State.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isInteger(message.code))
                        return "code: integer expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                return null;
            };

            /**
             * Creates a State message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.State
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.State} State
             */
            State.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.State)
                    return object;
                let message = new $root.imminer.msggateway.State();
                if (object.code != null)
                    message.code = object.code | 0;
                if (object.message != null)
                    message.message = String(object.message);
                return message;
            };

            /**
             * Creates a plain object from a State message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.State
             * @static
             * @param {imminer.msggateway.State} message State
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            State.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.code = 0;
                    object.message = "";
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                return object;
            };

            /**
             * Converts this State to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.State
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            State.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for State
             * @function getTypeUrl
             * @memberof imminer.msggateway.State
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            State.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.State";
            };

            return State;
        })();

        msggateway.MsgEntityToServer = (function() {

            /**
             * Properties of a MsgEntityToServer.
             * @memberof imminer.msggateway
             * @interface IMsgEntityToServer
             * @property {imminer.msggateway.MsgType|null} [msgType] MsgEntityToServer msgType
             * @property {number|Long|null} [seq] MsgEntityToServer seq
             * @property {imminer.msggateway.IJoin|null} [join] MsgEntityToServer join
             * @property {imminer.msggateway.IMsgBody|null} [msgBody] MsgEntityToServer msgBody
             */

            /**
             * Constructs a new MsgEntityToServer.
             * @memberof imminer.msggateway
             * @classdesc Represents a MsgEntityToServer.
             * @implements IMsgEntityToServer
             * @constructor
             * @param {imminer.msggateway.IMsgEntityToServer=} [properties] Properties to set
             */
            function MsgEntityToServer(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MsgEntityToServer msgType.
             * @member {imminer.msggateway.MsgType} msgType
             * @memberof imminer.msggateway.MsgEntityToServer
             * @instance
             */
            MsgEntityToServer.prototype.msgType = 0;

            /**
             * MsgEntityToServer seq.
             * @member {number|Long} seq
             * @memberof imminer.msggateway.MsgEntityToServer
             * @instance
             */
            MsgEntityToServer.prototype.seq = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MsgEntityToServer join.
             * @member {imminer.msggateway.IJoin|null|undefined} join
             * @memberof imminer.msggateway.MsgEntityToServer
             * @instance
             */
            MsgEntityToServer.prototype.join = null;

            /**
             * MsgEntityToServer msgBody.
             * @member {imminer.msggateway.IMsgBody|null|undefined} msgBody
             * @memberof imminer.msggateway.MsgEntityToServer
             * @instance
             */
            MsgEntityToServer.prototype.msgBody = null;

            /**
             * Creates a new MsgEntityToServer instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {imminer.msggateway.IMsgEntityToServer=} [properties] Properties to set
             * @returns {imminer.msggateway.MsgEntityToServer} MsgEntityToServer instance
             */
            MsgEntityToServer.create = function create(properties) {
                return new MsgEntityToServer(properties);
            };

            /**
             * Encodes the specified MsgEntityToServer message. Does not implicitly {@link imminer.msggateway.MsgEntityToServer.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {imminer.msggateway.IMsgEntityToServer} message MsgEntityToServer message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MsgEntityToServer.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.msgType);
                if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.seq);
                if (message.join != null && Object.hasOwnProperty.call(message, "join"))
                    $root.imminer.msggateway.Join.encode(message.join, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.msgBody != null && Object.hasOwnProperty.call(message, "msgBody"))
                    $root.imminer.msggateway.MsgBody.encode(message.msgBody, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MsgEntityToServer message, length delimited. Does not implicitly {@link imminer.msggateway.MsgEntityToServer.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {imminer.msggateway.IMsgEntityToServer} message MsgEntityToServer message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MsgEntityToServer.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MsgEntityToServer message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.MsgEntityToServer} MsgEntityToServer
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MsgEntityToServer.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.MsgEntityToServer();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.msgType = reader.int32();
                            break;
                        }
                    case 2: {
                            message.seq = reader.int64();
                            break;
                        }
                    case 3: {
                            message.join = $root.imminer.msggateway.Join.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.msgBody = $root.imminer.msggateway.MsgBody.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MsgEntityToServer message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.MsgEntityToServer} MsgEntityToServer
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MsgEntityToServer.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MsgEntityToServer message.
             * @function verify
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MsgEntityToServer.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.msgType != null && message.hasOwnProperty("msgType"))
                    switch (message.msgType) {
                    default:
                        return "msgType: enum value expected";
                    case 0:
                    case 1:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        break;
                    }
                if (message.seq != null && message.hasOwnProperty("seq"))
                    if (!$util.isInteger(message.seq) && !(message.seq && $util.isInteger(message.seq.low) && $util.isInteger(message.seq.high)))
                        return "seq: integer|Long expected";
                if (message.join != null && message.hasOwnProperty("join")) {
                    let error = $root.imminer.msggateway.Join.verify(message.join);
                    if (error)
                        return "join." + error;
                }
                if (message.msgBody != null && message.hasOwnProperty("msgBody")) {
                    let error = $root.imminer.msggateway.MsgBody.verify(message.msgBody);
                    if (error)
                        return "msgBody." + error;
                }
                return null;
            };

            /**
             * Creates a MsgEntityToServer message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.MsgEntityToServer} MsgEntityToServer
             */
            MsgEntityToServer.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.MsgEntityToServer)
                    return object;
                let message = new $root.imminer.msggateway.MsgEntityToServer();
                switch (object.msgType) {
                default:
                    if (typeof object.msgType === "number") {
                        message.msgType = object.msgType;
                        break;
                    }
                    break;
                case "JoinServer":
                case 0:
                    message.msgType = 0;
                    break;
                case "TextMsgType":
                case 1:
                    message.msgType = 1;
                    break;
                case "CreateSessionMsgType":
                case 4:
                    message.msgType = 4;
                    break;
                case "AgentUserJoinSessionMsgType":
                case 5:
                    message.msgType = 5;
                    break;
                case "HasReadReceiptMsgType":
                case 6:
                    message.msgType = 6;
                    break;
                case "KickOffLineMsgType":
                case 7:
                    message.msgType = 7;
                    break;
                case "EndSessionMsgType":
                case 8:
                    message.msgType = 8;
                    break;
                }
                if (object.seq != null)
                    if ($util.Long)
                        (message.seq = $util.Long.fromValue(object.seq)).unsigned = false;
                    else if (typeof object.seq === "string")
                        message.seq = parseInt(object.seq, 10);
                    else if (typeof object.seq === "number")
                        message.seq = object.seq;
                    else if (typeof object.seq === "object")
                        message.seq = new $util.LongBits(object.seq.low >>> 0, object.seq.high >>> 0).toNumber();
                if (object.join != null) {
                    if (typeof object.join !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToServer.join: object expected");
                    message.join = $root.imminer.msggateway.Join.fromObject(object.join);
                }
                if (object.msgBody != null) {
                    if (typeof object.msgBody !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToServer.msgBody: object expected");
                    message.msgBody = $root.imminer.msggateway.MsgBody.fromObject(object.msgBody);
                }
                return message;
            };

            /**
             * Creates a plain object from a MsgEntityToServer message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {imminer.msggateway.MsgEntityToServer} message MsgEntityToServer
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MsgEntityToServer.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.msgType = options.enums === String ? "JoinServer" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seq = options.longs === String ? "0" : 0;
                    object.join = null;
                    object.msgBody = null;
                }
                if (message.msgType != null && message.hasOwnProperty("msgType"))
                    object.msgType = options.enums === String ? $root.imminer.msggateway.MsgType[message.msgType] === undefined ? message.msgType : $root.imminer.msggateway.MsgType[message.msgType] : message.msgType;
                if (message.seq != null && message.hasOwnProperty("seq"))
                    if (typeof message.seq === "number")
                        object.seq = options.longs === String ? String(message.seq) : message.seq;
                    else
                        object.seq = options.longs === String ? $util.Long.prototype.toString.call(message.seq) : options.longs === Number ? new $util.LongBits(message.seq.low >>> 0, message.seq.high >>> 0).toNumber() : message.seq;
                if (message.join != null && message.hasOwnProperty("join"))
                    object.join = $root.imminer.msggateway.Join.toObject(message.join, options);
                if (message.msgBody != null && message.hasOwnProperty("msgBody"))
                    object.msgBody = $root.imminer.msggateway.MsgBody.toObject(message.msgBody, options);
                return object;
            };

            /**
             * Converts this MsgEntityToServer to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.MsgEntityToServer
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MsgEntityToServer.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MsgEntityToServer
             * @function getTypeUrl
             * @memberof imminer.msggateway.MsgEntityToServer
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MsgEntityToServer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.MsgEntityToServer";
            };

            return MsgEntityToServer;
        })();

        msggateway.MsgEntityToFrontEnd = (function() {

            /**
             * Properties of a MsgEntityToFrontEnd.
             * @memberof imminer.msggateway
             * @interface IMsgEntityToFrontEnd
             * @property {imminer.msggateway.MsgType|null} [msgType] MsgEntityToFrontEnd msgType
             * @property {imminer.msggateway.IState|null} [state] MsgEntityToFrontEnd state
             * @property {imminer.msggateway.IMsgBody|null} [msgBody] MsgEntityToFrontEnd msgBody
             * @property {imminer.msggateway.ICreateSessionMsg|null} [createSessionMsg] MsgEntityToFrontEnd createSessionMsg
             * @property {imminer.msggateway.IAgentUserJoinSessionMsg|null} [agentUserJoinSessionMsg] MsgEntityToFrontEnd agentUserJoinSessionMsg
             * @property {imminer.msggateway.IHasReadReceiptMsg|null} [hasReadReceiptMsg] MsgEntityToFrontEnd hasReadReceiptMsg
             * @property {imminer.msggateway.IEndSessionMsg|null} [endSessionMsg] MsgEntityToFrontEnd endSessionMsg
             */

            /**
             * Constructs a new MsgEntityToFrontEnd.
             * @memberof imminer.msggateway
             * @classdesc Represents a MsgEntityToFrontEnd.
             * @implements IMsgEntityToFrontEnd
             * @constructor
             * @param {imminer.msggateway.IMsgEntityToFrontEnd=} [properties] Properties to set
             */
            function MsgEntityToFrontEnd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MsgEntityToFrontEnd msgType.
             * @member {imminer.msggateway.MsgType} msgType
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.msgType = 0;

            /**
             * MsgEntityToFrontEnd state.
             * @member {imminer.msggateway.IState|null|undefined} state
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.state = null;

            /**
             * MsgEntityToFrontEnd msgBody.
             * @member {imminer.msggateway.IMsgBody|null|undefined} msgBody
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.msgBody = null;

            /**
             * MsgEntityToFrontEnd createSessionMsg.
             * @member {imminer.msggateway.ICreateSessionMsg|null|undefined} createSessionMsg
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.createSessionMsg = null;

            /**
             * MsgEntityToFrontEnd agentUserJoinSessionMsg.
             * @member {imminer.msggateway.IAgentUserJoinSessionMsg|null|undefined} agentUserJoinSessionMsg
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.agentUserJoinSessionMsg = null;

            /**
             * MsgEntityToFrontEnd hasReadReceiptMsg.
             * @member {imminer.msggateway.IHasReadReceiptMsg|null|undefined} hasReadReceiptMsg
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.hasReadReceiptMsg = null;

            /**
             * MsgEntityToFrontEnd endSessionMsg.
             * @member {imminer.msggateway.IEndSessionMsg|null|undefined} endSessionMsg
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             */
            MsgEntityToFrontEnd.prototype.endSessionMsg = null;

            /**
             * Creates a new MsgEntityToFrontEnd instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {imminer.msggateway.IMsgEntityToFrontEnd=} [properties] Properties to set
             * @returns {imminer.msggateway.MsgEntityToFrontEnd} MsgEntityToFrontEnd instance
             */
            MsgEntityToFrontEnd.create = function create(properties) {
                return new MsgEntityToFrontEnd(properties);
            };

            /**
             * Encodes the specified MsgEntityToFrontEnd message. Does not implicitly {@link imminer.msggateway.MsgEntityToFrontEnd.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {imminer.msggateway.IMsgEntityToFrontEnd} message MsgEntityToFrontEnd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MsgEntityToFrontEnd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.msgType);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    $root.imminer.msggateway.State.encode(message.state, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.msgBody != null && Object.hasOwnProperty.call(message, "msgBody"))
                    $root.imminer.msggateway.MsgBody.encode(message.msgBody, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.createSessionMsg != null && Object.hasOwnProperty.call(message, "createSessionMsg"))
                    $root.imminer.msggateway.CreateSessionMsg.encode(message.createSessionMsg, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.agentUserJoinSessionMsg != null && Object.hasOwnProperty.call(message, "agentUserJoinSessionMsg"))
                    $root.imminer.msggateway.AgentUserJoinSessionMsg.encode(message.agentUserJoinSessionMsg, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.hasReadReceiptMsg != null && Object.hasOwnProperty.call(message, "hasReadReceiptMsg"))
                    $root.imminer.msggateway.HasReadReceiptMsg.encode(message.hasReadReceiptMsg, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.endSessionMsg != null && Object.hasOwnProperty.call(message, "endSessionMsg"))
                    $root.imminer.msggateway.EndSessionMsg.encode(message.endSessionMsg, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MsgEntityToFrontEnd message, length delimited. Does not implicitly {@link imminer.msggateway.MsgEntityToFrontEnd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {imminer.msggateway.IMsgEntityToFrontEnd} message MsgEntityToFrontEnd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MsgEntityToFrontEnd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MsgEntityToFrontEnd message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.MsgEntityToFrontEnd} MsgEntityToFrontEnd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MsgEntityToFrontEnd.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.MsgEntityToFrontEnd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.msgType = reader.int32();
                            break;
                        }
                    case 2: {
                            message.state = $root.imminer.msggateway.State.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.msgBody = $root.imminer.msggateway.MsgBody.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.createSessionMsg = $root.imminer.msggateway.CreateSessionMsg.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.agentUserJoinSessionMsg = $root.imminer.msggateway.AgentUserJoinSessionMsg.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.hasReadReceiptMsg = $root.imminer.msggateway.HasReadReceiptMsg.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.endSessionMsg = $root.imminer.msggateway.EndSessionMsg.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MsgEntityToFrontEnd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.MsgEntityToFrontEnd} MsgEntityToFrontEnd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MsgEntityToFrontEnd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MsgEntityToFrontEnd message.
             * @function verify
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MsgEntityToFrontEnd.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.msgType != null && message.hasOwnProperty("msgType"))
                    switch (message.msgType) {
                    default:
                        return "msgType: enum value expected";
                    case 0:
                    case 1:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        break;
                    }
                if (message.state != null && message.hasOwnProperty("state")) {
                    let error = $root.imminer.msggateway.State.verify(message.state);
                    if (error)
                        return "state." + error;
                }
                if (message.msgBody != null && message.hasOwnProperty("msgBody")) {
                    let error = $root.imminer.msggateway.MsgBody.verify(message.msgBody);
                    if (error)
                        return "msgBody." + error;
                }
                if (message.createSessionMsg != null && message.hasOwnProperty("createSessionMsg")) {
                    let error = $root.imminer.msggateway.CreateSessionMsg.verify(message.createSessionMsg);
                    if (error)
                        return "createSessionMsg." + error;
                }
                if (message.agentUserJoinSessionMsg != null && message.hasOwnProperty("agentUserJoinSessionMsg")) {
                    let error = $root.imminer.msggateway.AgentUserJoinSessionMsg.verify(message.agentUserJoinSessionMsg);
                    if (error)
                        return "agentUserJoinSessionMsg." + error;
                }
                if (message.hasReadReceiptMsg != null && message.hasOwnProperty("hasReadReceiptMsg")) {
                    let error = $root.imminer.msggateway.HasReadReceiptMsg.verify(message.hasReadReceiptMsg);
                    if (error)
                        return "hasReadReceiptMsg." + error;
                }
                if (message.endSessionMsg != null && message.hasOwnProperty("endSessionMsg")) {
                    let error = $root.imminer.msggateway.EndSessionMsg.verify(message.endSessionMsg);
                    if (error)
                        return "endSessionMsg." + error;
                }
                return null;
            };

            /**
             * Creates a MsgEntityToFrontEnd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.MsgEntityToFrontEnd} MsgEntityToFrontEnd
             */
            MsgEntityToFrontEnd.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.MsgEntityToFrontEnd)
                    return object;
                let message = new $root.imminer.msggateway.MsgEntityToFrontEnd();
                switch (object.msgType) {
                default:
                    if (typeof object.msgType === "number") {
                        message.msgType = object.msgType;
                        break;
                    }
                    break;
                case "JoinServer":
                case 0:
                    message.msgType = 0;
                    break;
                case "TextMsgType":
                case 1:
                    message.msgType = 1;
                    break;
                case "CreateSessionMsgType":
                case 4:
                    message.msgType = 4;
                    break;
                case "AgentUserJoinSessionMsgType":
                case 5:
                    message.msgType = 5;
                    break;
                case "HasReadReceiptMsgType":
                case 6:
                    message.msgType = 6;
                    break;
                case "KickOffLineMsgType":
                case 7:
                    message.msgType = 7;
                    break;
                case "EndSessionMsgType":
                case 8:
                    message.msgType = 8;
                    break;
                }
                if (object.state != null) {
                    if (typeof object.state !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToFrontEnd.state: object expected");
                    message.state = $root.imminer.msggateway.State.fromObject(object.state);
                }
                if (object.msgBody != null) {
                    if (typeof object.msgBody !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToFrontEnd.msgBody: object expected");
                    message.msgBody = $root.imminer.msggateway.MsgBody.fromObject(object.msgBody);
                }
                if (object.createSessionMsg != null) {
                    if (typeof object.createSessionMsg !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToFrontEnd.createSessionMsg: object expected");
                    message.createSessionMsg = $root.imminer.msggateway.CreateSessionMsg.fromObject(object.createSessionMsg);
                }
                if (object.agentUserJoinSessionMsg != null) {
                    if (typeof object.agentUserJoinSessionMsg !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToFrontEnd.agentUserJoinSessionMsg: object expected");
                    message.agentUserJoinSessionMsg = $root.imminer.msggateway.AgentUserJoinSessionMsg.fromObject(object.agentUserJoinSessionMsg);
                }
                if (object.hasReadReceiptMsg != null) {
                    if (typeof object.hasReadReceiptMsg !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToFrontEnd.hasReadReceiptMsg: object expected");
                    message.hasReadReceiptMsg = $root.imminer.msggateway.HasReadReceiptMsg.fromObject(object.hasReadReceiptMsg);
                }
                if (object.endSessionMsg != null) {
                    if (typeof object.endSessionMsg !== "object")
                        throw TypeError(".imminer.msggateway.MsgEntityToFrontEnd.endSessionMsg: object expected");
                    message.endSessionMsg = $root.imminer.msggateway.EndSessionMsg.fromObject(object.endSessionMsg);
                }
                return message;
            };

            /**
             * Creates a plain object from a MsgEntityToFrontEnd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {imminer.msggateway.MsgEntityToFrontEnd} message MsgEntityToFrontEnd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MsgEntityToFrontEnd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.msgType = options.enums === String ? "JoinServer" : 0;
                    object.state = null;
                    object.msgBody = null;
                    object.createSessionMsg = null;
                    object.agentUserJoinSessionMsg = null;
                    object.hasReadReceiptMsg = null;
                    object.endSessionMsg = null;
                }
                if (message.msgType != null && message.hasOwnProperty("msgType"))
                    object.msgType = options.enums === String ? $root.imminer.msggateway.MsgType[message.msgType] === undefined ? message.msgType : $root.imminer.msggateway.MsgType[message.msgType] : message.msgType;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = $root.imminer.msggateway.State.toObject(message.state, options);
                if (message.msgBody != null && message.hasOwnProperty("msgBody"))
                    object.msgBody = $root.imminer.msggateway.MsgBody.toObject(message.msgBody, options);
                if (message.createSessionMsg != null && message.hasOwnProperty("createSessionMsg"))
                    object.createSessionMsg = $root.imminer.msggateway.CreateSessionMsg.toObject(message.createSessionMsg, options);
                if (message.agentUserJoinSessionMsg != null && message.hasOwnProperty("agentUserJoinSessionMsg"))
                    object.agentUserJoinSessionMsg = $root.imminer.msggateway.AgentUserJoinSessionMsg.toObject(message.agentUserJoinSessionMsg, options);
                if (message.hasReadReceiptMsg != null && message.hasOwnProperty("hasReadReceiptMsg"))
                    object.hasReadReceiptMsg = $root.imminer.msggateway.HasReadReceiptMsg.toObject(message.hasReadReceiptMsg, options);
                if (message.endSessionMsg != null && message.hasOwnProperty("endSessionMsg"))
                    object.endSessionMsg = $root.imminer.msggateway.EndSessionMsg.toObject(message.endSessionMsg, options);
                return object;
            };

            /**
             * Converts this MsgEntityToFrontEnd to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MsgEntityToFrontEnd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MsgEntityToFrontEnd
             * @function getTypeUrl
             * @memberof imminer.msggateway.MsgEntityToFrontEnd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MsgEntityToFrontEnd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.MsgEntityToFrontEnd";
            };

            return MsgEntityToFrontEnd;
        })();

        msggateway.Join = (function() {

            /**
             * Properties of a Join.
             * @memberof imminer.msggateway
             * @interface IJoin
             * @property {string|null} [uid] Join uid
             * @property {string|null} [sessionId] Join sessionId
             * @property {string|null} [token] Join token
             */

            /**
             * Constructs a new Join.
             * @memberof imminer.msggateway
             * @classdesc Represents a Join.
             * @implements IJoin
             * @constructor
             * @param {imminer.msggateway.IJoin=} [properties] Properties to set
             */
            function Join(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Join uid.
             * @member {string} uid
             * @memberof imminer.msggateway.Join
             * @instance
             */
            Join.prototype.uid = "";

            /**
             * Join sessionId.
             * @member {string} sessionId
             * @memberof imminer.msggateway.Join
             * @instance
             */
            Join.prototype.sessionId = "";

            /**
             * Join token.
             * @member {string} token
             * @memberof imminer.msggateway.Join
             * @instance
             */
            Join.prototype.token = "";

            /**
             * Creates a new Join instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.Join
             * @static
             * @param {imminer.msggateway.IJoin=} [properties] Properties to set
             * @returns {imminer.msggateway.Join} Join instance
             */
            Join.create = function create(properties) {
                return new Join(properties);
            };

            /**
             * Encodes the specified Join message. Does not implicitly {@link imminer.msggateway.Join.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.Join
             * @static
             * @param {imminer.msggateway.IJoin} message Join message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Join.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
                if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.sessionId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
                return writer;
            };

            /**
             * Encodes the specified Join message, length delimited. Does not implicitly {@link imminer.msggateway.Join.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.Join
             * @static
             * @param {imminer.msggateway.IJoin} message Join message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Join.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Join message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.Join
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.Join} Join
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Join.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.Join();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.uid = reader.string();
                            break;
                        }
                    case 2: {
                            message.sessionId = reader.string();
                            break;
                        }
                    case 3: {
                            message.token = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Join message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.Join
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.Join} Join
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Join.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Join message.
             * @function verify
             * @memberof imminer.msggateway.Join
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Join.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    if (!$util.isString(message.sessionId))
                        return "sessionId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                return null;
            };

            /**
             * Creates a Join message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.Join
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.Join} Join
             */
            Join.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.Join)
                    return object;
                let message = new $root.imminer.msggateway.Join();
                if (object.uid != null)
                    message.uid = String(object.uid);
                if (object.sessionId != null)
                    message.sessionId = String(object.sessionId);
                if (object.token != null)
                    message.token = String(object.token);
                return message;
            };

            /**
             * Creates a plain object from a Join message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.Join
             * @static
             * @param {imminer.msggateway.Join} message Join
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Join.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.uid = "";
                    object.sessionId = "";
                    object.token = "";
                }
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    object.sessionId = message.sessionId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                return object;
            };

            /**
             * Converts this Join to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.Join
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Join.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Join
             * @function getTypeUrl
             * @memberof imminer.msggateway.Join
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Join.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.Join";
            };

            return Join;
        })();

        msggateway.JoinResp = (function() {

            /**
             * Properties of a JoinResp.
             * @memberof imminer.msggateway
             * @interface IJoinResp
             * @property {string|null} [sessionId] JoinResp sessionId
             * @property {string|null} [serverId] JoinResp serverId
             */

            /**
             * Constructs a new JoinResp.
             * @memberof imminer.msggateway
             * @classdesc Represents a JoinResp.
             * @implements IJoinResp
             * @constructor
             * @param {imminer.msggateway.IJoinResp=} [properties] Properties to set
             */
            function JoinResp(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * JoinResp sessionId.
             * @member {string} sessionId
             * @memberof imminer.msggateway.JoinResp
             * @instance
             */
            JoinResp.prototype.sessionId = "";

            /**
             * JoinResp serverId.
             * @member {string} serverId
             * @memberof imminer.msggateway.JoinResp
             * @instance
             */
            JoinResp.prototype.serverId = "";

            /**
             * Creates a new JoinResp instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {imminer.msggateway.IJoinResp=} [properties] Properties to set
             * @returns {imminer.msggateway.JoinResp} JoinResp instance
             */
            JoinResp.create = function create(properties) {
                return new JoinResp(properties);
            };

            /**
             * Encodes the specified JoinResp message. Does not implicitly {@link imminer.msggateway.JoinResp.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {imminer.msggateway.IJoinResp} message JoinResp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            JoinResp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionId);
                if (message.serverId != null && Object.hasOwnProperty.call(message, "serverId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.serverId);
                return writer;
            };

            /**
             * Encodes the specified JoinResp message, length delimited. Does not implicitly {@link imminer.msggateway.JoinResp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {imminer.msggateway.IJoinResp} message JoinResp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            JoinResp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a JoinResp message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.JoinResp} JoinResp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            JoinResp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.JoinResp();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.sessionId = reader.string();
                            break;
                        }
                    case 2: {
                            message.serverId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a JoinResp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.JoinResp} JoinResp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            JoinResp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a JoinResp message.
             * @function verify
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            JoinResp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    if (!$util.isString(message.sessionId))
                        return "sessionId: string expected";
                if (message.serverId != null && message.hasOwnProperty("serverId"))
                    if (!$util.isString(message.serverId))
                        return "serverId: string expected";
                return null;
            };

            /**
             * Creates a JoinResp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.JoinResp} JoinResp
             */
            JoinResp.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.JoinResp)
                    return object;
                let message = new $root.imminer.msggateway.JoinResp();
                if (object.sessionId != null)
                    message.sessionId = String(object.sessionId);
                if (object.serverId != null)
                    message.serverId = String(object.serverId);
                return message;
            };

            /**
             * Creates a plain object from a JoinResp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {imminer.msggateway.JoinResp} message JoinResp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            JoinResp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.sessionId = "";
                    object.serverId = "";
                }
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    object.sessionId = message.sessionId;
                if (message.serverId != null && message.hasOwnProperty("serverId"))
                    object.serverId = message.serverId;
                return object;
            };

            /**
             * Converts this JoinResp to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.JoinResp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            JoinResp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for JoinResp
             * @function getTypeUrl
             * @memberof imminer.msggateway.JoinResp
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            JoinResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.JoinResp";
            };

            return JoinResp;
        })();

        msggateway.MsgBody = (function() {

            /**
             * Properties of a MsgBody.
             * @memberof imminer.msggateway
             * @interface IMsgBody
             * @property {string|null} [senderUid] MsgBody senderUid
             * @property {string|null} [receiverUid] MsgBody receiverUid
             * @property {imminer.msggateway.ContentType|null} [msgType] MsgBody msgType
             * @property {number|null} [msgSeq] MsgBody msgSeq
             * @property {string|null} [encKey] MsgBody encKey
             * @property {string|null} [msgBody] MsgBody msgBody
             * @property {number|null} [status] MsgBody status
             * @property {number|Long|null} [createTime] MsgBody createTime
             * @property {string|null} [clientMsgID] MsgBody clientMsgID
             * @property {string|null} [sessionId] MsgBody sessionId
             * @property {string|null} [sendTime] MsgBody sendTime
             * @property {string|null} [title] MsgBody title
             * @property {string|null} [senderNickname] MsgBody senderNickname
             * @property {string|null} [senderFaceURL] MsgBody senderFaceURL
             * @property {string|null} [serverMsgID] MsgBody serverMsgID
             */

            /**
             * Constructs a new MsgBody.
             * @memberof imminer.msggateway
             * @classdesc Represents a MsgBody.
             * @implements IMsgBody
             * @constructor
             * @param {imminer.msggateway.IMsgBody=} [properties] Properties to set
             */
            function MsgBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MsgBody senderUid.
             * @member {string} senderUid
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.senderUid = "";

            /**
             * MsgBody receiverUid.
             * @member {string} receiverUid
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.receiverUid = "";

            /**
             * MsgBody msgType.
             * @member {imminer.msggateway.ContentType} msgType
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.msgType = 0;

            /**
             * MsgBody msgSeq.
             * @member {number} msgSeq
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.msgSeq = 0;

            /**
             * MsgBody encKey.
             * @member {string} encKey
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.encKey = "";

            /**
             * MsgBody msgBody.
             * @member {string} msgBody
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.msgBody = "";

            /**
             * MsgBody status.
             * @member {number} status
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.status = 0;

            /**
             * MsgBody createTime.
             * @member {number|Long} createTime
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * MsgBody clientMsgID.
             * @member {string} clientMsgID
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.clientMsgID = "";

            /**
             * MsgBody sessionId.
             * @member {string} sessionId
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.sessionId = "";

            /**
             * MsgBody sendTime.
             * @member {string} sendTime
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.sendTime = "";

            /**
             * MsgBody title.
             * @member {string} title
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.title = "";

            /**
             * MsgBody senderNickname.
             * @member {string} senderNickname
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.senderNickname = "";

            /**
             * MsgBody senderFaceURL.
             * @member {string} senderFaceURL
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.senderFaceURL = "";

            /**
             * MsgBody serverMsgID.
             * @member {string} serverMsgID
             * @memberof imminer.msggateway.MsgBody
             * @instance
             */
            MsgBody.prototype.serverMsgID = "";

            /**
             * Creates a new MsgBody instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {imminer.msggateway.IMsgBody=} [properties] Properties to set
             * @returns {imminer.msggateway.MsgBody} MsgBody instance
             */
            MsgBody.create = function create(properties) {
                return new MsgBody(properties);
            };

            /**
             * Encodes the specified MsgBody message. Does not implicitly {@link imminer.msggateway.MsgBody.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {imminer.msggateway.IMsgBody} message MsgBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MsgBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.senderUid != null && Object.hasOwnProperty.call(message, "senderUid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.senderUid);
                if (message.receiverUid != null && Object.hasOwnProperty.call(message, "receiverUid"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.receiverUid);
                if (message.msgType != null && Object.hasOwnProperty.call(message, "msgType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.msgType);
                if (message.msgSeq != null && Object.hasOwnProperty.call(message, "msgSeq"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.msgSeq);
                if (message.encKey != null && Object.hasOwnProperty.call(message, "encKey"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.encKey);
                if (message.msgBody != null && Object.hasOwnProperty.call(message, "msgBody"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.msgBody);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
                if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTime);
                if (message.clientMsgID != null && Object.hasOwnProperty.call(message, "clientMsgID"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.clientMsgID);
                if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.sessionId);
                if (message.sendTime != null && Object.hasOwnProperty.call(message, "sendTime"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.sendTime);
                if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.title);
                if (message.senderNickname != null && Object.hasOwnProperty.call(message, "senderNickname"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.senderNickname);
                if (message.senderFaceURL != null && Object.hasOwnProperty.call(message, "senderFaceURL"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.senderFaceURL);
                if (message.serverMsgID != null && Object.hasOwnProperty.call(message, "serverMsgID"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.serverMsgID);
                return writer;
            };

            /**
             * Encodes the specified MsgBody message, length delimited. Does not implicitly {@link imminer.msggateway.MsgBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {imminer.msggateway.IMsgBody} message MsgBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MsgBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MsgBody message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.MsgBody} MsgBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MsgBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.MsgBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.senderUid = reader.string();
                            break;
                        }
                    case 2: {
                            message.receiverUid = reader.string();
                            break;
                        }
                    case 3: {
                            message.msgType = reader.int32();
                            break;
                        }
                    case 4: {
                            message.msgSeq = reader.int32();
                            break;
                        }
                    case 5: {
                            message.encKey = reader.string();
                            break;
                        }
                    case 6: {
                            message.msgBody = reader.string();
                            break;
                        }
                    case 7: {
                            message.status = reader.int32();
                            break;
                        }
                    case 8: {
                            message.createTime = reader.int64();
                            break;
                        }
                    case 9: {
                            message.clientMsgID = reader.string();
                            break;
                        }
                    case 10: {
                            message.sessionId = reader.string();
                            break;
                        }
                    case 11: {
                            message.sendTime = reader.string();
                            break;
                        }
                    case 12: {
                            message.title = reader.string();
                            break;
                        }
                    case 13: {
                            message.senderNickname = reader.string();
                            break;
                        }
                    case 14: {
                            message.senderFaceURL = reader.string();
                            break;
                        }
                    case 15: {
                            message.serverMsgID = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MsgBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.MsgBody} MsgBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MsgBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MsgBody message.
             * @function verify
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MsgBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.senderUid != null && message.hasOwnProperty("senderUid"))
                    if (!$util.isString(message.senderUid))
                        return "senderUid: string expected";
                if (message.receiverUid != null && message.hasOwnProperty("receiverUid"))
                    if (!$util.isString(message.receiverUid))
                        return "receiverUid: string expected";
                if (message.msgType != null && message.hasOwnProperty("msgType"))
                    switch (message.msgType) {
                    default:
                        return "msgType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                        break;
                    }
                if (message.msgSeq != null && message.hasOwnProperty("msgSeq"))
                    if (!$util.isInteger(message.msgSeq))
                        return "msgSeq: integer expected";
                if (message.encKey != null && message.hasOwnProperty("encKey"))
                    if (!$util.isString(message.encKey))
                        return "encKey: string expected";
                if (message.msgBody != null && message.hasOwnProperty("msgBody"))
                    if (!$util.isString(message.msgBody))
                        return "msgBody: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isInteger(message.status))
                        return "status: integer expected";
                if (message.createTime != null && message.hasOwnProperty("createTime"))
                    if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                        return "createTime: integer|Long expected";
                if (message.clientMsgID != null && message.hasOwnProperty("clientMsgID"))
                    if (!$util.isString(message.clientMsgID))
                        return "clientMsgID: string expected";
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    if (!$util.isString(message.sessionId))
                        return "sessionId: string expected";
                if (message.sendTime != null && message.hasOwnProperty("sendTime"))
                    if (!$util.isString(message.sendTime))
                        return "sendTime: string expected";
                if (message.title != null && message.hasOwnProperty("title"))
                    if (!$util.isString(message.title))
                        return "title: string expected";
                if (message.senderNickname != null && message.hasOwnProperty("senderNickname"))
                    if (!$util.isString(message.senderNickname))
                        return "senderNickname: string expected";
                if (message.senderFaceURL != null && message.hasOwnProperty("senderFaceURL"))
                    if (!$util.isString(message.senderFaceURL))
                        return "senderFaceURL: string expected";
                if (message.serverMsgID != null && message.hasOwnProperty("serverMsgID"))
                    if (!$util.isString(message.serverMsgID))
                        return "serverMsgID: string expected";
                return null;
            };

            /**
             * Creates a MsgBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.MsgBody} MsgBody
             */
            MsgBody.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.MsgBody)
                    return object;
                let message = new $root.imminer.msggateway.MsgBody();
                if (object.senderUid != null)
                    message.senderUid = String(object.senderUid);
                if (object.receiverUid != null)
                    message.receiverUid = String(object.receiverUid);
                switch (object.msgType) {
                default:
                    if (typeof object.msgType === "number") {
                        message.msgType = object.msgType;
                        break;
                    }
                    break;
                case "TextContentType":
                case 0:
                    message.msgType = 0;
                    break;
                case "ImgContentType":
                case 1:
                    message.msgType = 1;
                    break;
                case "VideoContentType":
                case 2:
                    message.msgType = 2;
                    break;
                case "FaqContentType":
                case 3:
                    message.msgType = 3;
                    break;
                case "KnowledgePointContentType":
                case 4:
                    message.msgType = 4;
                    break;
                case "KnowledgeAnswerContentType":
                case 5:
                    message.msgType = 5;
                    break;
                case "SystemContentType":
                case 6:
                    message.msgType = 6;
                    break;
                case "CreateSessionContentType":
                case 7:
                    message.msgType = 7;
                    break;
                case "AgentUserJoinSessionContentType":
                case 8:
                    message.msgType = 8;
                    break;
                case "EndSessionContentType":
                case 9:
                    message.msgType = 9;
                    break;
                case "RankingContentType":
                case 10:
                    message.msgType = 10;
                    break;
                case "TransferContentType":
                case 11:
                    message.msgType = 11;
                    break;
                case "UnsupportedContentType":
                case 12:
                    message.msgType = 12;
                    break;
                }
                if (object.msgSeq != null)
                    message.msgSeq = object.msgSeq | 0;
                if (object.encKey != null)
                    message.encKey = String(object.encKey);
                if (object.msgBody != null)
                    message.msgBody = String(object.msgBody);
                if (object.status != null)
                    message.status = object.status | 0;
                if (object.createTime != null)
                    if ($util.Long)
                        (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                    else if (typeof object.createTime === "string")
                        message.createTime = parseInt(object.createTime, 10);
                    else if (typeof object.createTime === "number")
                        message.createTime = object.createTime;
                    else if (typeof object.createTime === "object")
                        message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
                if (object.clientMsgID != null)
                    message.clientMsgID = String(object.clientMsgID);
                if (object.sessionId != null)
                    message.sessionId = String(object.sessionId);
                if (object.sendTime != null)
                    message.sendTime = String(object.sendTime);
                if (object.title != null)
                    message.title = String(object.title);
                if (object.senderNickname != null)
                    message.senderNickname = String(object.senderNickname);
                if (object.senderFaceURL != null)
                    message.senderFaceURL = String(object.senderFaceURL);
                if (object.serverMsgID != null)
                    message.serverMsgID = String(object.serverMsgID);
                return message;
            };

            /**
             * Creates a plain object from a MsgBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {imminer.msggateway.MsgBody} message MsgBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MsgBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.senderUid = "";
                    object.receiverUid = "";
                    object.msgType = options.enums === String ? "TextContentType" : 0;
                    object.msgSeq = 0;
                    object.encKey = "";
                    object.msgBody = "";
                    object.status = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.createTime = options.longs === String ? "0" : 0;
                    object.clientMsgID = "";
                    object.sessionId = "";
                    object.sendTime = "";
                    object.title = "";
                    object.senderNickname = "";
                    object.senderFaceURL = "";
                    object.serverMsgID = "";
                }
                if (message.senderUid != null && message.hasOwnProperty("senderUid"))
                    object.senderUid = message.senderUid;
                if (message.receiverUid != null && message.hasOwnProperty("receiverUid"))
                    object.receiverUid = message.receiverUid;
                if (message.msgType != null && message.hasOwnProperty("msgType"))
                    object.msgType = options.enums === String ? $root.imminer.msggateway.ContentType[message.msgType] === undefined ? message.msgType : $root.imminer.msggateway.ContentType[message.msgType] : message.msgType;
                if (message.msgSeq != null && message.hasOwnProperty("msgSeq"))
                    object.msgSeq = message.msgSeq;
                if (message.encKey != null && message.hasOwnProperty("encKey"))
                    object.encKey = message.encKey;
                if (message.msgBody != null && message.hasOwnProperty("msgBody"))
                    object.msgBody = message.msgBody;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.createTime != null && message.hasOwnProperty("createTime"))
                    if (typeof message.createTime === "number")
                        object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                    else
                        object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
                if (message.clientMsgID != null && message.hasOwnProperty("clientMsgID"))
                    object.clientMsgID = message.clientMsgID;
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    object.sessionId = message.sessionId;
                if (message.sendTime != null && message.hasOwnProperty("sendTime"))
                    object.sendTime = message.sendTime;
                if (message.title != null && message.hasOwnProperty("title"))
                    object.title = message.title;
                if (message.senderNickname != null && message.hasOwnProperty("senderNickname"))
                    object.senderNickname = message.senderNickname;
                if (message.senderFaceURL != null && message.hasOwnProperty("senderFaceURL"))
                    object.senderFaceURL = message.senderFaceURL;
                if (message.serverMsgID != null && message.hasOwnProperty("serverMsgID"))
                    object.serverMsgID = message.serverMsgID;
                return object;
            };

            /**
             * Converts this MsgBody to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.MsgBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MsgBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MsgBody
             * @function getTypeUrl
             * @memberof imminer.msggateway.MsgBody
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MsgBody.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.MsgBody";
            };

            return MsgBody;
        })();

        msggateway.SessionBasic = (function() {

            /**
             * Properties of a SessionBasic.
             * @memberof imminer.msggateway
             * @interface ISessionBasic
             * @property {string|null} [sessionId] SessionBasic sessionId
             * @property {string|null} [headIcon] SessionBasic headIcon
             * @property {string|null} [uid] SessionBasic uid
             * @property {string|null} [source] SessionBasic source
             * @property {string|null} [nickName] SessionBasic nickName
             * @property {string|null} [devNo] SessionBasic devNo
             * @property {number|Long|null} [createTime] SessionBasic createTime
             * @property {string|null} [language] SessionBasic language
             * @property {string|null} [extra] SessionBasic extra
             * @property {imminer.msggateway.IMsgBody|null} [latestMsg] SessionBasic latestMsg
             */

            /**
             * Constructs a new SessionBasic.
             * @memberof imminer.msggateway
             * @classdesc Represents a SessionBasic.
             * @implements ISessionBasic
             * @constructor
             * @param {imminer.msggateway.ISessionBasic=} [properties] Properties to set
             */
            function SessionBasic(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SessionBasic sessionId.
             * @member {string} sessionId
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.sessionId = "";

            /**
             * SessionBasic headIcon.
             * @member {string} headIcon
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.headIcon = "";

            /**
             * SessionBasic uid.
             * @member {string} uid
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.uid = "";

            /**
             * SessionBasic source.
             * @member {string} source
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.source = "";

            /**
             * SessionBasic nickName.
             * @member {string} nickName
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.nickName = "";

            /**
             * SessionBasic devNo.
             * @member {string} devNo
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.devNo = "";

            /**
             * SessionBasic createTime.
             * @member {number|Long} createTime
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * SessionBasic language.
             * @member {string} language
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.language = "";

            /**
             * SessionBasic extra.
             * @member {string} extra
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.extra = "";

            /**
             * SessionBasic latestMsg.
             * @member {imminer.msggateway.IMsgBody|null|undefined} latestMsg
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             */
            SessionBasic.prototype.latestMsg = null;

            /**
             * Creates a new SessionBasic instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {imminer.msggateway.ISessionBasic=} [properties] Properties to set
             * @returns {imminer.msggateway.SessionBasic} SessionBasic instance
             */
            SessionBasic.create = function create(properties) {
                return new SessionBasic(properties);
            };

            /**
             * Encodes the specified SessionBasic message. Does not implicitly {@link imminer.msggateway.SessionBasic.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {imminer.msggateway.ISessionBasic} message SessionBasic message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SessionBasic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionId);
                if (message.headIcon != null && Object.hasOwnProperty.call(message, "headIcon"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.headIcon);
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.uid);
                if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.source);
                if (message.nickName != null && Object.hasOwnProperty.call(message, "nickName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickName);
                if (message.devNo != null && Object.hasOwnProperty.call(message, "devNo"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.devNo);
                if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTime);
                if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.language);
                if (message.extra != null && Object.hasOwnProperty.call(message, "extra"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.extra);
                if (message.latestMsg != null && Object.hasOwnProperty.call(message, "latestMsg"))
                    $root.imminer.msggateway.MsgBody.encode(message.latestMsg, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SessionBasic message, length delimited. Does not implicitly {@link imminer.msggateway.SessionBasic.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {imminer.msggateway.ISessionBasic} message SessionBasic message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SessionBasic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SessionBasic message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.SessionBasic} SessionBasic
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SessionBasic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.SessionBasic();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.sessionId = reader.string();
                            break;
                        }
                    case 2: {
                            message.headIcon = reader.string();
                            break;
                        }
                    case 3: {
                            message.uid = reader.string();
                            break;
                        }
                    case 4: {
                            message.source = reader.string();
                            break;
                        }
                    case 5: {
                            message.nickName = reader.string();
                            break;
                        }
                    case 6: {
                            message.devNo = reader.string();
                            break;
                        }
                    case 7: {
                            message.createTime = reader.int64();
                            break;
                        }
                    case 8: {
                            message.language = reader.string();
                            break;
                        }
                    case 9: {
                            message.extra = reader.string();
                            break;
                        }
                    case 10: {
                            message.latestMsg = $root.imminer.msggateway.MsgBody.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SessionBasic message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.SessionBasic} SessionBasic
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SessionBasic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SessionBasic message.
             * @function verify
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SessionBasic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    if (!$util.isString(message.sessionId))
                        return "sessionId: string expected";
                if (message.headIcon != null && message.hasOwnProperty("headIcon"))
                    if (!$util.isString(message.headIcon))
                        return "headIcon: string expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                if (message.source != null && message.hasOwnProperty("source"))
                    if (!$util.isString(message.source))
                        return "source: string expected";
                if (message.nickName != null && message.hasOwnProperty("nickName"))
                    if (!$util.isString(message.nickName))
                        return "nickName: string expected";
                if (message.devNo != null && message.hasOwnProperty("devNo"))
                    if (!$util.isString(message.devNo))
                        return "devNo: string expected";
                if (message.createTime != null && message.hasOwnProperty("createTime"))
                    if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                        return "createTime: integer|Long expected";
                if (message.language != null && message.hasOwnProperty("language"))
                    if (!$util.isString(message.language))
                        return "language: string expected";
                if (message.extra != null && message.hasOwnProperty("extra"))
                    if (!$util.isString(message.extra))
                        return "extra: string expected";
                if (message.latestMsg != null && message.hasOwnProperty("latestMsg")) {
                    let error = $root.imminer.msggateway.MsgBody.verify(message.latestMsg);
                    if (error)
                        return "latestMsg." + error;
                }
                return null;
            };

            /**
             * Creates a SessionBasic message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.SessionBasic} SessionBasic
             */
            SessionBasic.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.SessionBasic)
                    return object;
                let message = new $root.imminer.msggateway.SessionBasic();
                if (object.sessionId != null)
                    message.sessionId = String(object.sessionId);
                if (object.headIcon != null)
                    message.headIcon = String(object.headIcon);
                if (object.uid != null)
                    message.uid = String(object.uid);
                if (object.source != null)
                    message.source = String(object.source);
                if (object.nickName != null)
                    message.nickName = String(object.nickName);
                if (object.devNo != null)
                    message.devNo = String(object.devNo);
                if (object.createTime != null)
                    if ($util.Long)
                        (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                    else if (typeof object.createTime === "string")
                        message.createTime = parseInt(object.createTime, 10);
                    else if (typeof object.createTime === "number")
                        message.createTime = object.createTime;
                    else if (typeof object.createTime === "object")
                        message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
                if (object.language != null)
                    message.language = String(object.language);
                if (object.extra != null)
                    message.extra = String(object.extra);
                if (object.latestMsg != null) {
                    if (typeof object.latestMsg !== "object")
                        throw TypeError(".imminer.msggateway.SessionBasic.latestMsg: object expected");
                    message.latestMsg = $root.imminer.msggateway.MsgBody.fromObject(object.latestMsg);
                }
                return message;
            };

            /**
             * Creates a plain object from a SessionBasic message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {imminer.msggateway.SessionBasic} message SessionBasic
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SessionBasic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.sessionId = "";
                    object.headIcon = "";
                    object.uid = "";
                    object.source = "";
                    object.nickName = "";
                    object.devNo = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.createTime = options.longs === String ? "0" : 0;
                    object.language = "";
                    object.extra = "";
                    object.latestMsg = null;
                }
                if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                    object.sessionId = message.sessionId;
                if (message.headIcon != null && message.hasOwnProperty("headIcon"))
                    object.headIcon = message.headIcon;
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                if (message.source != null && message.hasOwnProperty("source"))
                    object.source = message.source;
                if (message.nickName != null && message.hasOwnProperty("nickName"))
                    object.nickName = message.nickName;
                if (message.devNo != null && message.hasOwnProperty("devNo"))
                    object.devNo = message.devNo;
                if (message.createTime != null && message.hasOwnProperty("createTime"))
                    if (typeof message.createTime === "number")
                        object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                    else
                        object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
                if (message.language != null && message.hasOwnProperty("language"))
                    object.language = message.language;
                if (message.extra != null && message.hasOwnProperty("extra"))
                    object.extra = message.extra;
                if (message.latestMsg != null && message.hasOwnProperty("latestMsg"))
                    object.latestMsg = $root.imminer.msggateway.MsgBody.toObject(message.latestMsg, options);
                return object;
            };

            /**
             * Converts this SessionBasic to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.SessionBasic
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SessionBasic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SessionBasic
             * @function getTypeUrl
             * @memberof imminer.msggateway.SessionBasic
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SessionBasic.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.SessionBasic";
            };

            return SessionBasic;
        })();

        msggateway.CreateSessionMsg = (function() {

            /**
             * Properties of a CreateSessionMsg.
             * @memberof imminer.msggateway
             * @interface ICreateSessionMsg
             * @property {imminer.msggateway.ISessionBasic|null} [sessionBasic] CreateSessionMsg sessionBasic
             */

            /**
             * Constructs a new CreateSessionMsg.
             * @memberof imminer.msggateway
             * @classdesc Represents a CreateSessionMsg.
             * @implements ICreateSessionMsg
             * @constructor
             * @param {imminer.msggateway.ICreateSessionMsg=} [properties] Properties to set
             */
            function CreateSessionMsg(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateSessionMsg sessionBasic.
             * @member {imminer.msggateway.ISessionBasic|null|undefined} sessionBasic
             * @memberof imminer.msggateway.CreateSessionMsg
             * @instance
             */
            CreateSessionMsg.prototype.sessionBasic = null;

            /**
             * Creates a new CreateSessionMsg instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {imminer.msggateway.ICreateSessionMsg=} [properties] Properties to set
             * @returns {imminer.msggateway.CreateSessionMsg} CreateSessionMsg instance
             */
            CreateSessionMsg.create = function create(properties) {
                return new CreateSessionMsg(properties);
            };

            /**
             * Encodes the specified CreateSessionMsg message. Does not implicitly {@link imminer.msggateway.CreateSessionMsg.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {imminer.msggateway.ICreateSessionMsg} message CreateSessionMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSessionMsg.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sessionBasic != null && Object.hasOwnProperty.call(message, "sessionBasic"))
                    $root.imminer.msggateway.SessionBasic.encode(message.sessionBasic, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CreateSessionMsg message, length delimited. Does not implicitly {@link imminer.msggateway.CreateSessionMsg.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {imminer.msggateway.ICreateSessionMsg} message CreateSessionMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSessionMsg.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSessionMsg message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.CreateSessionMsg} CreateSessionMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSessionMsg.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.CreateSessionMsg();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.sessionBasic = $root.imminer.msggateway.SessionBasic.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSessionMsg message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.CreateSessionMsg} CreateSessionMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSessionMsg.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSessionMsg message.
             * @function verify
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSessionMsg.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sessionBasic != null && message.hasOwnProperty("sessionBasic")) {
                    let error = $root.imminer.msggateway.SessionBasic.verify(message.sessionBasic);
                    if (error)
                        return "sessionBasic." + error;
                }
                return null;
            };

            /**
             * Creates a CreateSessionMsg message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.CreateSessionMsg} CreateSessionMsg
             */
            CreateSessionMsg.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.CreateSessionMsg)
                    return object;
                let message = new $root.imminer.msggateway.CreateSessionMsg();
                if (object.sessionBasic != null) {
                    if (typeof object.sessionBasic !== "object")
                        throw TypeError(".imminer.msggateway.CreateSessionMsg.sessionBasic: object expected");
                    message.sessionBasic = $root.imminer.msggateway.SessionBasic.fromObject(object.sessionBasic);
                }
                return message;
            };

            /**
             * Creates a plain object from a CreateSessionMsg message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {imminer.msggateway.CreateSessionMsg} message CreateSessionMsg
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSessionMsg.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.sessionBasic = null;
                if (message.sessionBasic != null && message.hasOwnProperty("sessionBasic"))
                    object.sessionBasic = $root.imminer.msggateway.SessionBasic.toObject(message.sessionBasic, options);
                return object;
            };

            /**
             * Converts this CreateSessionMsg to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.CreateSessionMsg
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSessionMsg.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreateSessionMsg
             * @function getTypeUrl
             * @memberof imminer.msggateway.CreateSessionMsg
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreateSessionMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.CreateSessionMsg";
            };

            return CreateSessionMsg;
        })();

        msggateway.AgentUserJoinSessionMsg = (function() {

            /**
             * Properties of an AgentUserJoinSessionMsg.
             * @memberof imminer.msggateway
             * @interface IAgentUserJoinSessionMsg
             * @property {string|null} [username] AgentUserJoinSessionMsg username
             */

            /**
             * Constructs a new AgentUserJoinSessionMsg.
             * @memberof imminer.msggateway
             * @classdesc Represents an AgentUserJoinSessionMsg.
             * @implements IAgentUserJoinSessionMsg
             * @constructor
             * @param {imminer.msggateway.IAgentUserJoinSessionMsg=} [properties] Properties to set
             */
            function AgentUserJoinSessionMsg(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AgentUserJoinSessionMsg username.
             * @member {string} username
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @instance
             */
            AgentUserJoinSessionMsg.prototype.username = "";

            /**
             * Creates a new AgentUserJoinSessionMsg instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {imminer.msggateway.IAgentUserJoinSessionMsg=} [properties] Properties to set
             * @returns {imminer.msggateway.AgentUserJoinSessionMsg} AgentUserJoinSessionMsg instance
             */
            AgentUserJoinSessionMsg.create = function create(properties) {
                return new AgentUserJoinSessionMsg(properties);
            };

            /**
             * Encodes the specified AgentUserJoinSessionMsg message. Does not implicitly {@link imminer.msggateway.AgentUserJoinSessionMsg.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {imminer.msggateway.IAgentUserJoinSessionMsg} message AgentUserJoinSessionMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AgentUserJoinSessionMsg.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.username);
                return writer;
            };

            /**
             * Encodes the specified AgentUserJoinSessionMsg message, length delimited. Does not implicitly {@link imminer.msggateway.AgentUserJoinSessionMsg.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {imminer.msggateway.IAgentUserJoinSessionMsg} message AgentUserJoinSessionMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AgentUserJoinSessionMsg.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AgentUserJoinSessionMsg message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.AgentUserJoinSessionMsg} AgentUserJoinSessionMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AgentUserJoinSessionMsg.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.AgentUserJoinSessionMsg();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.username = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AgentUserJoinSessionMsg message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.AgentUserJoinSessionMsg} AgentUserJoinSessionMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AgentUserJoinSessionMsg.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AgentUserJoinSessionMsg message.
             * @function verify
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AgentUserJoinSessionMsg.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.username != null && message.hasOwnProperty("username"))
                    if (!$util.isString(message.username))
                        return "username: string expected";
                return null;
            };

            /**
             * Creates an AgentUserJoinSessionMsg message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.AgentUserJoinSessionMsg} AgentUserJoinSessionMsg
             */
            AgentUserJoinSessionMsg.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.AgentUserJoinSessionMsg)
                    return object;
                let message = new $root.imminer.msggateway.AgentUserJoinSessionMsg();
                if (object.username != null)
                    message.username = String(object.username);
                return message;
            };

            /**
             * Creates a plain object from an AgentUserJoinSessionMsg message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {imminer.msggateway.AgentUserJoinSessionMsg} message AgentUserJoinSessionMsg
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AgentUserJoinSessionMsg.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.username = "";
                if (message.username != null && message.hasOwnProperty("username"))
                    object.username = message.username;
                return object;
            };

            /**
             * Converts this AgentUserJoinSessionMsg to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AgentUserJoinSessionMsg.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AgentUserJoinSessionMsg
             * @function getTypeUrl
             * @memberof imminer.msggateway.AgentUserJoinSessionMsg
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AgentUserJoinSessionMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.AgentUserJoinSessionMsg";
            };

            return AgentUserJoinSessionMsg;
        })();

        msggateway.HasReadReceiptMsg = (function() {

            /**
             * Properties of a HasReadReceiptMsg.
             * @memberof imminer.msggateway
             * @interface IHasReadReceiptMsg
             * @property {string|null} [sessionID] HasReadReceiptMsg sessionID
             * @property {Array.<number|Long>|null} [hasReadSeqs] HasReadReceiptMsg hasReadSeqs
             */

            /**
             * Constructs a new HasReadReceiptMsg.
             * @memberof imminer.msggateway
             * @classdesc Represents a HasReadReceiptMsg.
             * @implements IHasReadReceiptMsg
             * @constructor
             * @param {imminer.msggateway.IHasReadReceiptMsg=} [properties] Properties to set
             */
            function HasReadReceiptMsg(properties) {
                this.hasReadSeqs = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * HasReadReceiptMsg sessionID.
             * @member {string} sessionID
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @instance
             */
            HasReadReceiptMsg.prototype.sessionID = "";

            /**
             * HasReadReceiptMsg hasReadSeqs.
             * @member {Array.<number|Long>} hasReadSeqs
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @instance
             */
            HasReadReceiptMsg.prototype.hasReadSeqs = $util.emptyArray;

            /**
             * Creates a new HasReadReceiptMsg instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {imminer.msggateway.IHasReadReceiptMsg=} [properties] Properties to set
             * @returns {imminer.msggateway.HasReadReceiptMsg} HasReadReceiptMsg instance
             */
            HasReadReceiptMsg.create = function create(properties) {
                return new HasReadReceiptMsg(properties);
            };

            /**
             * Encodes the specified HasReadReceiptMsg message. Does not implicitly {@link imminer.msggateway.HasReadReceiptMsg.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {imminer.msggateway.IHasReadReceiptMsg} message HasReadReceiptMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HasReadReceiptMsg.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sessionID != null && Object.hasOwnProperty.call(message, "sessionID"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionID);
                if (message.hasReadSeqs != null && message.hasReadSeqs.length) {
                    writer.uint32(/* id 2, wireType 2 =*/18).fork();
                    for (let i = 0; i < message.hasReadSeqs.length; ++i)
                        writer.int64(message.hasReadSeqs[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified HasReadReceiptMsg message, length delimited. Does not implicitly {@link imminer.msggateway.HasReadReceiptMsg.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {imminer.msggateway.IHasReadReceiptMsg} message HasReadReceiptMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HasReadReceiptMsg.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a HasReadReceiptMsg message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.HasReadReceiptMsg} HasReadReceiptMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HasReadReceiptMsg.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.HasReadReceiptMsg();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.sessionID = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.hasReadSeqs && message.hasReadSeqs.length))
                                message.hasReadSeqs = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.hasReadSeqs.push(reader.int64());
                            } else
                                message.hasReadSeqs.push(reader.int64());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a HasReadReceiptMsg message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.HasReadReceiptMsg} HasReadReceiptMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HasReadReceiptMsg.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a HasReadReceiptMsg message.
             * @function verify
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            HasReadReceiptMsg.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sessionID != null && message.hasOwnProperty("sessionID"))
                    if (!$util.isString(message.sessionID))
                        return "sessionID: string expected";
                if (message.hasReadSeqs != null && message.hasOwnProperty("hasReadSeqs")) {
                    if (!Array.isArray(message.hasReadSeqs))
                        return "hasReadSeqs: array expected";
                    for (let i = 0; i < message.hasReadSeqs.length; ++i)
                        if (!$util.isInteger(message.hasReadSeqs[i]) && !(message.hasReadSeqs[i] && $util.isInteger(message.hasReadSeqs[i].low) && $util.isInteger(message.hasReadSeqs[i].high)))
                            return "hasReadSeqs: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates a HasReadReceiptMsg message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.HasReadReceiptMsg} HasReadReceiptMsg
             */
            HasReadReceiptMsg.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.HasReadReceiptMsg)
                    return object;
                let message = new $root.imminer.msggateway.HasReadReceiptMsg();
                if (object.sessionID != null)
                    message.sessionID = String(object.sessionID);
                if (object.hasReadSeqs) {
                    if (!Array.isArray(object.hasReadSeqs))
                        throw TypeError(".imminer.msggateway.HasReadReceiptMsg.hasReadSeqs: array expected");
                    message.hasReadSeqs = [];
                    for (let i = 0; i < object.hasReadSeqs.length; ++i)
                        if ($util.Long)
                            (message.hasReadSeqs[i] = $util.Long.fromValue(object.hasReadSeqs[i])).unsigned = false;
                        else if (typeof object.hasReadSeqs[i] === "string")
                            message.hasReadSeqs[i] = parseInt(object.hasReadSeqs[i], 10);
                        else if (typeof object.hasReadSeqs[i] === "number")
                            message.hasReadSeqs[i] = object.hasReadSeqs[i];
                        else if (typeof object.hasReadSeqs[i] === "object")
                            message.hasReadSeqs[i] = new $util.LongBits(object.hasReadSeqs[i].low >>> 0, object.hasReadSeqs[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from a HasReadReceiptMsg message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {imminer.msggateway.HasReadReceiptMsg} message HasReadReceiptMsg
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            HasReadReceiptMsg.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.hasReadSeqs = [];
                if (options.defaults)
                    object.sessionID = "";
                if (message.sessionID != null && message.hasOwnProperty("sessionID"))
                    object.sessionID = message.sessionID;
                if (message.hasReadSeqs && message.hasReadSeqs.length) {
                    object.hasReadSeqs = [];
                    for (let j = 0; j < message.hasReadSeqs.length; ++j)
                        if (typeof message.hasReadSeqs[j] === "number")
                            object.hasReadSeqs[j] = options.longs === String ? String(message.hasReadSeqs[j]) : message.hasReadSeqs[j];
                        else
                            object.hasReadSeqs[j] = options.longs === String ? $util.Long.prototype.toString.call(message.hasReadSeqs[j]) : options.longs === Number ? new $util.LongBits(message.hasReadSeqs[j].low >>> 0, message.hasReadSeqs[j].high >>> 0).toNumber() : message.hasReadSeqs[j];
                }
                return object;
            };

            /**
             * Converts this HasReadReceiptMsg to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            HasReadReceiptMsg.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for HasReadReceiptMsg
             * @function getTypeUrl
             * @memberof imminer.msggateway.HasReadReceiptMsg
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            HasReadReceiptMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.HasReadReceiptMsg";
            };

            return HasReadReceiptMsg;
        })();

        msggateway.KickOffLineMsg = (function() {

            /**
             * Properties of a KickOffLineMsg.
             * @memberof imminer.msggateway
             * @interface IKickOffLineMsg
             * @property {string|null} [userID] KickOffLineMsg userID
             * @property {string|null} [identityID] KickOffLineMsg identityID
             */

            /**
             * Constructs a new KickOffLineMsg.
             * @memberof imminer.msggateway
             * @classdesc Represents a KickOffLineMsg.
             * @implements IKickOffLineMsg
             * @constructor
             * @param {imminer.msggateway.IKickOffLineMsg=} [properties] Properties to set
             */
            function KickOffLineMsg(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * KickOffLineMsg userID.
             * @member {string} userID
             * @memberof imminer.msggateway.KickOffLineMsg
             * @instance
             */
            KickOffLineMsg.prototype.userID = "";

            /**
             * KickOffLineMsg identityID.
             * @member {string} identityID
             * @memberof imminer.msggateway.KickOffLineMsg
             * @instance
             */
            KickOffLineMsg.prototype.identityID = "";

            /**
             * Creates a new KickOffLineMsg instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {imminer.msggateway.IKickOffLineMsg=} [properties] Properties to set
             * @returns {imminer.msggateway.KickOffLineMsg} KickOffLineMsg instance
             */
            KickOffLineMsg.create = function create(properties) {
                return new KickOffLineMsg(properties);
            };

            /**
             * Encodes the specified KickOffLineMsg message. Does not implicitly {@link imminer.msggateway.KickOffLineMsg.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {imminer.msggateway.IKickOffLineMsg} message KickOffLineMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            KickOffLineMsg.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userID != null && Object.hasOwnProperty.call(message, "userID"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userID);
                if (message.identityID != null && Object.hasOwnProperty.call(message, "identityID"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.identityID);
                return writer;
            };

            /**
             * Encodes the specified KickOffLineMsg message, length delimited. Does not implicitly {@link imminer.msggateway.KickOffLineMsg.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {imminer.msggateway.IKickOffLineMsg} message KickOffLineMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            KickOffLineMsg.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a KickOffLineMsg message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.KickOffLineMsg} KickOffLineMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            KickOffLineMsg.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.KickOffLineMsg();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.userID = reader.string();
                            break;
                        }
                    case 2: {
                            message.identityID = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a KickOffLineMsg message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.KickOffLineMsg} KickOffLineMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            KickOffLineMsg.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a KickOffLineMsg message.
             * @function verify
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            KickOffLineMsg.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userID != null && message.hasOwnProperty("userID"))
                    if (!$util.isString(message.userID))
                        return "userID: string expected";
                if (message.identityID != null && message.hasOwnProperty("identityID"))
                    if (!$util.isString(message.identityID))
                        return "identityID: string expected";
                return null;
            };

            /**
             * Creates a KickOffLineMsg message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.KickOffLineMsg} KickOffLineMsg
             */
            KickOffLineMsg.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.KickOffLineMsg)
                    return object;
                let message = new $root.imminer.msggateway.KickOffLineMsg();
                if (object.userID != null)
                    message.userID = String(object.userID);
                if (object.identityID != null)
                    message.identityID = String(object.identityID);
                return message;
            };

            /**
             * Creates a plain object from a KickOffLineMsg message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {imminer.msggateway.KickOffLineMsg} message KickOffLineMsg
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            KickOffLineMsg.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.userID = "";
                    object.identityID = "";
                }
                if (message.userID != null && message.hasOwnProperty("userID"))
                    object.userID = message.userID;
                if (message.identityID != null && message.hasOwnProperty("identityID"))
                    object.identityID = message.identityID;
                return object;
            };

            /**
             * Converts this KickOffLineMsg to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.KickOffLineMsg
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            KickOffLineMsg.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for KickOffLineMsg
             * @function getTypeUrl
             * @memberof imminer.msggateway.KickOffLineMsg
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            KickOffLineMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.KickOffLineMsg";
            };

            return KickOffLineMsg;
        })();

        msggateway.EndSessionMsg = (function() {

            /**
             * Properties of an EndSessionMsg.
             * @memberof imminer.msggateway
             * @interface IEndSessionMsg
             * @property {string|null} [sessionID] EndSessionMsg sessionID
             */

            /**
             * Constructs a new EndSessionMsg.
             * @memberof imminer.msggateway
             * @classdesc Represents an EndSessionMsg.
             * @implements IEndSessionMsg
             * @constructor
             * @param {imminer.msggateway.IEndSessionMsg=} [properties] Properties to set
             */
            function EndSessionMsg(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EndSessionMsg sessionID.
             * @member {string} sessionID
             * @memberof imminer.msggateway.EndSessionMsg
             * @instance
             */
            EndSessionMsg.prototype.sessionID = "";

            /**
             * Creates a new EndSessionMsg instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {imminer.msggateway.IEndSessionMsg=} [properties] Properties to set
             * @returns {imminer.msggateway.EndSessionMsg} EndSessionMsg instance
             */
            EndSessionMsg.create = function create(properties) {
                return new EndSessionMsg(properties);
            };

            /**
             * Encodes the specified EndSessionMsg message. Does not implicitly {@link imminer.msggateway.EndSessionMsg.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {imminer.msggateway.IEndSessionMsg} message EndSessionMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndSessionMsg.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sessionID != null && Object.hasOwnProperty.call(message, "sessionID"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionID);
                return writer;
            };

            /**
             * Encodes the specified EndSessionMsg message, length delimited. Does not implicitly {@link imminer.msggateway.EndSessionMsg.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {imminer.msggateway.IEndSessionMsg} message EndSessionMsg message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndSessionMsg.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EndSessionMsg message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.EndSessionMsg} EndSessionMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndSessionMsg.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.EndSessionMsg();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.sessionID = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EndSessionMsg message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.EndSessionMsg} EndSessionMsg
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndSessionMsg.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EndSessionMsg message.
             * @function verify
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EndSessionMsg.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sessionID != null && message.hasOwnProperty("sessionID"))
                    if (!$util.isString(message.sessionID))
                        return "sessionID: string expected";
                return null;
            };

            /**
             * Creates an EndSessionMsg message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.EndSessionMsg} EndSessionMsg
             */
            EndSessionMsg.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.EndSessionMsg)
                    return object;
                let message = new $root.imminer.msggateway.EndSessionMsg();
                if (object.sessionID != null)
                    message.sessionID = String(object.sessionID);
                return message;
            };

            /**
             * Creates a plain object from an EndSessionMsg message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {imminer.msggateway.EndSessionMsg} message EndSessionMsg
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EndSessionMsg.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.sessionID = "";
                if (message.sessionID != null && message.hasOwnProperty("sessionID"))
                    object.sessionID = message.sessionID;
                return object;
            };

            /**
             * Converts this EndSessionMsg to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.EndSessionMsg
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EndSessionMsg.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EndSessionMsg
             * @function getTypeUrl
             * @memberof imminer.msggateway.EndSessionMsg
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EndSessionMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.EndSessionMsg";
            };

            return EndSessionMsg;
        })();

        msggateway.CreateSessionContent = (function() {

            /**
             * Properties of a CreateSessionContent.
             * @memberof imminer.msggateway
             * @interface ICreateSessionContent
             * @property {number|Long|null} [joinTime] CreateSessionContent joinTime
             */

            /**
             * Constructs a new CreateSessionContent.
             * @memberof imminer.msggateway
             * @classdesc Represents a CreateSessionContent.
             * @implements ICreateSessionContent
             * @constructor
             * @param {imminer.msggateway.ICreateSessionContent=} [properties] Properties to set
             */
            function CreateSessionContent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateSessionContent joinTime.
             * @member {number|Long} joinTime
             * @memberof imminer.msggateway.CreateSessionContent
             * @instance
             */
            CreateSessionContent.prototype.joinTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new CreateSessionContent instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {imminer.msggateway.ICreateSessionContent=} [properties] Properties to set
             * @returns {imminer.msggateway.CreateSessionContent} CreateSessionContent instance
             */
            CreateSessionContent.create = function create(properties) {
                return new CreateSessionContent(properties);
            };

            /**
             * Encodes the specified CreateSessionContent message. Does not implicitly {@link imminer.msggateway.CreateSessionContent.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {imminer.msggateway.ICreateSessionContent} message CreateSessionContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSessionContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.joinTime != null && Object.hasOwnProperty.call(message, "joinTime"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.joinTime);
                return writer;
            };

            /**
             * Encodes the specified CreateSessionContent message, length delimited. Does not implicitly {@link imminer.msggateway.CreateSessionContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {imminer.msggateway.ICreateSessionContent} message CreateSessionContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSessionContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSessionContent message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.CreateSessionContent} CreateSessionContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSessionContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.CreateSessionContent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.joinTime = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSessionContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.CreateSessionContent} CreateSessionContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSessionContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSessionContent message.
             * @function verify
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSessionContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.joinTime != null && message.hasOwnProperty("joinTime"))
                    if (!$util.isInteger(message.joinTime) && !(message.joinTime && $util.isInteger(message.joinTime.low) && $util.isInteger(message.joinTime.high)))
                        return "joinTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a CreateSessionContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.CreateSessionContent} CreateSessionContent
             */
            CreateSessionContent.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.CreateSessionContent)
                    return object;
                let message = new $root.imminer.msggateway.CreateSessionContent();
                if (object.joinTime != null)
                    if ($util.Long)
                        (message.joinTime = $util.Long.fromValue(object.joinTime)).unsigned = false;
                    else if (typeof object.joinTime === "string")
                        message.joinTime = parseInt(object.joinTime, 10);
                    else if (typeof object.joinTime === "number")
                        message.joinTime = object.joinTime;
                    else if (typeof object.joinTime === "object")
                        message.joinTime = new $util.LongBits(object.joinTime.low >>> 0, object.joinTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a CreateSessionContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {imminer.msggateway.CreateSessionContent} message CreateSessionContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSessionContent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.joinTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.joinTime = options.longs === String ? "0" : 0;
                if (message.joinTime != null && message.hasOwnProperty("joinTime"))
                    if (typeof message.joinTime === "number")
                        object.joinTime = options.longs === String ? String(message.joinTime) : message.joinTime;
                    else
                        object.joinTime = options.longs === String ? $util.Long.prototype.toString.call(message.joinTime) : options.longs === Number ? new $util.LongBits(message.joinTime.low >>> 0, message.joinTime.high >>> 0).toNumber() : message.joinTime;
                return object;
            };

            /**
             * Converts this CreateSessionContent to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.CreateSessionContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSessionContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CreateSessionContent
             * @function getTypeUrl
             * @memberof imminer.msggateway.CreateSessionContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CreateSessionContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.CreateSessionContent";
            };

            return CreateSessionContent;
        })();

        msggateway.AgentUserJoinSessionContent = (function() {

            /**
             * Properties of an AgentUserJoinSessionContent.
             * @memberof imminer.msggateway
             * @interface IAgentUserJoinSessionContent
             * @property {string|null} [username] AgentUserJoinSessionContent username
             * @property {string|null} [faceUrl] AgentUserJoinSessionContent faceUrl
             * @property {number|Long|null} [joinTime] AgentUserJoinSessionContent joinTime
             */

            /**
             * Constructs a new AgentUserJoinSessionContent.
             * @memberof imminer.msggateway
             * @classdesc Represents an AgentUserJoinSessionContent.
             * @implements IAgentUserJoinSessionContent
             * @constructor
             * @param {imminer.msggateway.IAgentUserJoinSessionContent=} [properties] Properties to set
             */
            function AgentUserJoinSessionContent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AgentUserJoinSessionContent username.
             * @member {string} username
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @instance
             */
            AgentUserJoinSessionContent.prototype.username = "";

            /**
             * AgentUserJoinSessionContent faceUrl.
             * @member {string} faceUrl
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @instance
             */
            AgentUserJoinSessionContent.prototype.faceUrl = "";

            /**
             * AgentUserJoinSessionContent joinTime.
             * @member {number|Long} joinTime
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @instance
             */
            AgentUserJoinSessionContent.prototype.joinTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new AgentUserJoinSessionContent instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {imminer.msggateway.IAgentUserJoinSessionContent=} [properties] Properties to set
             * @returns {imminer.msggateway.AgentUserJoinSessionContent} AgentUserJoinSessionContent instance
             */
            AgentUserJoinSessionContent.create = function create(properties) {
                return new AgentUserJoinSessionContent(properties);
            };

            /**
             * Encodes the specified AgentUserJoinSessionContent message. Does not implicitly {@link imminer.msggateway.AgentUserJoinSessionContent.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {imminer.msggateway.IAgentUserJoinSessionContent} message AgentUserJoinSessionContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AgentUserJoinSessionContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.username);
                if (message.faceUrl != null && Object.hasOwnProperty.call(message, "faceUrl"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.faceUrl);
                if (message.joinTime != null && Object.hasOwnProperty.call(message, "joinTime"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.joinTime);
                return writer;
            };

            /**
             * Encodes the specified AgentUserJoinSessionContent message, length delimited. Does not implicitly {@link imminer.msggateway.AgentUserJoinSessionContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {imminer.msggateway.IAgentUserJoinSessionContent} message AgentUserJoinSessionContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AgentUserJoinSessionContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AgentUserJoinSessionContent message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.AgentUserJoinSessionContent} AgentUserJoinSessionContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AgentUserJoinSessionContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.AgentUserJoinSessionContent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.username = reader.string();
                            break;
                        }
                    case 2: {
                            message.faceUrl = reader.string();
                            break;
                        }
                    case 3: {
                            message.joinTime = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AgentUserJoinSessionContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.AgentUserJoinSessionContent} AgentUserJoinSessionContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AgentUserJoinSessionContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AgentUserJoinSessionContent message.
             * @function verify
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AgentUserJoinSessionContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.username != null && message.hasOwnProperty("username"))
                    if (!$util.isString(message.username))
                        return "username: string expected";
                if (message.faceUrl != null && message.hasOwnProperty("faceUrl"))
                    if (!$util.isString(message.faceUrl))
                        return "faceUrl: string expected";
                if (message.joinTime != null && message.hasOwnProperty("joinTime"))
                    if (!$util.isInteger(message.joinTime) && !(message.joinTime && $util.isInteger(message.joinTime.low) && $util.isInteger(message.joinTime.high)))
                        return "joinTime: integer|Long expected";
                return null;
            };

            /**
             * Creates an AgentUserJoinSessionContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.AgentUserJoinSessionContent} AgentUserJoinSessionContent
             */
            AgentUserJoinSessionContent.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.AgentUserJoinSessionContent)
                    return object;
                let message = new $root.imminer.msggateway.AgentUserJoinSessionContent();
                if (object.username != null)
                    message.username = String(object.username);
                if (object.faceUrl != null)
                    message.faceUrl = String(object.faceUrl);
                if (object.joinTime != null)
                    if ($util.Long)
                        (message.joinTime = $util.Long.fromValue(object.joinTime)).unsigned = false;
                    else if (typeof object.joinTime === "string")
                        message.joinTime = parseInt(object.joinTime, 10);
                    else if (typeof object.joinTime === "number")
                        message.joinTime = object.joinTime;
                    else if (typeof object.joinTime === "object")
                        message.joinTime = new $util.LongBits(object.joinTime.low >>> 0, object.joinTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an AgentUserJoinSessionContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {imminer.msggateway.AgentUserJoinSessionContent} message AgentUserJoinSessionContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AgentUserJoinSessionContent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.username = "";
                    object.faceUrl = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.joinTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.joinTime = options.longs === String ? "0" : 0;
                }
                if (message.username != null && message.hasOwnProperty("username"))
                    object.username = message.username;
                if (message.faceUrl != null && message.hasOwnProperty("faceUrl"))
                    object.faceUrl = message.faceUrl;
                if (message.joinTime != null && message.hasOwnProperty("joinTime"))
                    if (typeof message.joinTime === "number")
                        object.joinTime = options.longs === String ? String(message.joinTime) : message.joinTime;
                    else
                        object.joinTime = options.longs === String ? $util.Long.prototype.toString.call(message.joinTime) : options.longs === Number ? new $util.LongBits(message.joinTime.low >>> 0, message.joinTime.high >>> 0).toNumber() : message.joinTime;
                return object;
            };

            /**
             * Converts this AgentUserJoinSessionContent to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AgentUserJoinSessionContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AgentUserJoinSessionContent
             * @function getTypeUrl
             * @memberof imminer.msggateway.AgentUserJoinSessionContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AgentUserJoinSessionContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.AgentUserJoinSessionContent";
            };

            return AgentUserJoinSessionContent;
        })();

        msggateway.EndSessionContent = (function() {

            /**
             * Properties of an EndSessionContent.
             * @memberof imminer.msggateway
             * @interface IEndSessionContent
             * @property {number|Long|null} [endTime] EndSessionContent endTime
             */

            /**
             * Constructs a new EndSessionContent.
             * @memberof imminer.msggateway
             * @classdesc Represents an EndSessionContent.
             * @implements IEndSessionContent
             * @constructor
             * @param {imminer.msggateway.IEndSessionContent=} [properties] Properties to set
             */
            function EndSessionContent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EndSessionContent endTime.
             * @member {number|Long} endTime
             * @memberof imminer.msggateway.EndSessionContent
             * @instance
             */
            EndSessionContent.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new EndSessionContent instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {imminer.msggateway.IEndSessionContent=} [properties] Properties to set
             * @returns {imminer.msggateway.EndSessionContent} EndSessionContent instance
             */
            EndSessionContent.create = function create(properties) {
                return new EndSessionContent(properties);
            };

            /**
             * Encodes the specified EndSessionContent message. Does not implicitly {@link imminer.msggateway.EndSessionContent.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {imminer.msggateway.IEndSessionContent} message EndSessionContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndSessionContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.endTime);
                return writer;
            };

            /**
             * Encodes the specified EndSessionContent message, length delimited. Does not implicitly {@link imminer.msggateway.EndSessionContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {imminer.msggateway.IEndSessionContent} message EndSessionContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndSessionContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EndSessionContent message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.EndSessionContent} EndSessionContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndSessionContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.EndSessionContent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.endTime = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EndSessionContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.EndSessionContent} EndSessionContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndSessionContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EndSessionContent message.
             * @function verify
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EndSessionContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                        return "endTime: integer|Long expected";
                return null;
            };

            /**
             * Creates an EndSessionContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.EndSessionContent} EndSessionContent
             */
            EndSessionContent.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.EndSessionContent)
                    return object;
                let message = new $root.imminer.msggateway.EndSessionContent();
                if (object.endTime != null)
                    if ($util.Long)
                        (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                    else if (typeof object.endTime === "string")
                        message.endTime = parseInt(object.endTime, 10);
                    else if (typeof object.endTime === "number")
                        message.endTime = object.endTime;
                    else if (typeof object.endTime === "object")
                        message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an EndSessionContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {imminer.msggateway.EndSessionContent} message EndSessionContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EndSessionContent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.endTime = options.longs === String ? "0" : 0;
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    if (typeof message.endTime === "number")
                        object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                    else
                        object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                return object;
            };

            /**
             * Converts this EndSessionContent to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.EndSessionContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EndSessionContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EndSessionContent
             * @function getTypeUrl
             * @memberof imminer.msggateway.EndSessionContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EndSessionContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.EndSessionContent";
            };

            return EndSessionContent;
        })();

        msggateway.RankingContent = (function() {

            /**
             * Properties of a RankingContent.
             * @memberof imminer.msggateway
             * @interface IRankingContent
             * @property {number|null} [number] RankingContent number
             */

            /**
             * Constructs a new RankingContent.
             * @memberof imminer.msggateway
             * @classdesc Represents a RankingContent.
             * @implements IRankingContent
             * @constructor
             * @param {imminer.msggateway.IRankingContent=} [properties] Properties to set
             */
            function RankingContent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RankingContent number.
             * @member {number} number
             * @memberof imminer.msggateway.RankingContent
             * @instance
             */
            RankingContent.prototype.number = 0;

            /**
             * Creates a new RankingContent instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {imminer.msggateway.IRankingContent=} [properties] Properties to set
             * @returns {imminer.msggateway.RankingContent} RankingContent instance
             */
            RankingContent.create = function create(properties) {
                return new RankingContent(properties);
            };

            /**
             * Encodes the specified RankingContent message. Does not implicitly {@link imminer.msggateway.RankingContent.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {imminer.msggateway.IRankingContent} message RankingContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RankingContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.number);
                return writer;
            };

            /**
             * Encodes the specified RankingContent message, length delimited. Does not implicitly {@link imminer.msggateway.RankingContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {imminer.msggateway.IRankingContent} message RankingContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RankingContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RankingContent message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.RankingContent} RankingContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RankingContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.RankingContent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.number = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RankingContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.RankingContent} RankingContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RankingContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RankingContent message.
             * @function verify
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RankingContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                return null;
            };

            /**
             * Creates a RankingContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.RankingContent} RankingContent
             */
            RankingContent.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.RankingContent)
                    return object;
                let message = new $root.imminer.msggateway.RankingContent();
                if (object.number != null)
                    message.number = object.number | 0;
                return message;
            };

            /**
             * Creates a plain object from a RankingContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {imminer.msggateway.RankingContent} message RankingContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RankingContent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.number = 0;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                return object;
            };

            /**
             * Converts this RankingContent to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.RankingContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RankingContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RankingContent
             * @function getTypeUrl
             * @memberof imminer.msggateway.RankingContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RankingContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.RankingContent";
            };

            return RankingContent;
        })();

        msggateway.TransferContent = (function() {

            /**
             * Properties of a TransferContent.
             * @memberof imminer.msggateway
             * @interface ITransferContent
             * @property {number|Long|null} [transferTime] TransferContent transferTime
             */

            /**
             * Constructs a new TransferContent.
             * @memberof imminer.msggateway
             * @classdesc Represents a TransferContent.
             * @implements ITransferContent
             * @constructor
             * @param {imminer.msggateway.ITransferContent=} [properties] Properties to set
             */
            function TransferContent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TransferContent transferTime.
             * @member {number|Long} transferTime
             * @memberof imminer.msggateway.TransferContent
             * @instance
             */
            TransferContent.prototype.transferTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new TransferContent instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {imminer.msggateway.ITransferContent=} [properties] Properties to set
             * @returns {imminer.msggateway.TransferContent} TransferContent instance
             */
            TransferContent.create = function create(properties) {
                return new TransferContent(properties);
            };

            /**
             * Encodes the specified TransferContent message. Does not implicitly {@link imminer.msggateway.TransferContent.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {imminer.msggateway.ITransferContent} message TransferContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransferContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transferTime != null && Object.hasOwnProperty.call(message, "transferTime"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.transferTime);
                return writer;
            };

            /**
             * Encodes the specified TransferContent message, length delimited. Does not implicitly {@link imminer.msggateway.TransferContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {imminer.msggateway.ITransferContent} message TransferContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransferContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TransferContent message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.TransferContent} TransferContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransferContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.TransferContent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.transferTime = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TransferContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.TransferContent} TransferContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransferContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TransferContent message.
             * @function verify
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TransferContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transferTime != null && message.hasOwnProperty("transferTime"))
                    if (!$util.isInteger(message.transferTime) && !(message.transferTime && $util.isInteger(message.transferTime.low) && $util.isInteger(message.transferTime.high)))
                        return "transferTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a TransferContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.TransferContent} TransferContent
             */
            TransferContent.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.TransferContent)
                    return object;
                let message = new $root.imminer.msggateway.TransferContent();
                if (object.transferTime != null)
                    if ($util.Long)
                        (message.transferTime = $util.Long.fromValue(object.transferTime)).unsigned = false;
                    else if (typeof object.transferTime === "string")
                        message.transferTime = parseInt(object.transferTime, 10);
                    else if (typeof object.transferTime === "number")
                        message.transferTime = object.transferTime;
                    else if (typeof object.transferTime === "object")
                        message.transferTime = new $util.LongBits(object.transferTime.low >>> 0, object.transferTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a TransferContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {imminer.msggateway.TransferContent} message TransferContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TransferContent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.transferTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.transferTime = options.longs === String ? "0" : 0;
                if (message.transferTime != null && message.hasOwnProperty("transferTime"))
                    if (typeof message.transferTime === "number")
                        object.transferTime = options.longs === String ? String(message.transferTime) : message.transferTime;
                    else
                        object.transferTime = options.longs === String ? $util.Long.prototype.toString.call(message.transferTime) : options.longs === Number ? new $util.LongBits(message.transferTime.low >>> 0, message.transferTime.high >>> 0).toNumber() : message.transferTime;
                return object;
            };

            /**
             * Converts this TransferContent to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.TransferContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TransferContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TransferContent
             * @function getTypeUrl
             * @memberof imminer.msggateway.TransferContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TransferContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.TransferContent";
            };

            return TransferContent;
        })();

        msggateway.UnsupportedContent = (function() {

            /**
             * Properties of an UnsupportedContent.
             * @memberof imminer.msggateway
             * @interface IUnsupportedContent
             */

            /**
             * Constructs a new UnsupportedContent.
             * @memberof imminer.msggateway
             * @classdesc Represents an UnsupportedContent.
             * @implements IUnsupportedContent
             * @constructor
             * @param {imminer.msggateway.IUnsupportedContent=} [properties] Properties to set
             */
            function UnsupportedContent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UnsupportedContent instance using the specified properties.
             * @function create
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {imminer.msggateway.IUnsupportedContent=} [properties] Properties to set
             * @returns {imminer.msggateway.UnsupportedContent} UnsupportedContent instance
             */
            UnsupportedContent.create = function create(properties) {
                return new UnsupportedContent(properties);
            };

            /**
             * Encodes the specified UnsupportedContent message. Does not implicitly {@link imminer.msggateway.UnsupportedContent.verify|verify} messages.
             * @function encode
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {imminer.msggateway.IUnsupportedContent} message UnsupportedContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnsupportedContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UnsupportedContent message, length delimited. Does not implicitly {@link imminer.msggateway.UnsupportedContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {imminer.msggateway.IUnsupportedContent} message UnsupportedContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnsupportedContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UnsupportedContent message from the specified reader or buffer.
             * @function decode
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {imminer.msggateway.UnsupportedContent} UnsupportedContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnsupportedContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.imminer.msggateway.UnsupportedContent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UnsupportedContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {imminer.msggateway.UnsupportedContent} UnsupportedContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnsupportedContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UnsupportedContent message.
             * @function verify
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UnsupportedContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UnsupportedContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {imminer.msggateway.UnsupportedContent} UnsupportedContent
             */
            UnsupportedContent.fromObject = function fromObject(object) {
                if (object instanceof $root.imminer.msggateway.UnsupportedContent)
                    return object;
                return new $root.imminer.msggateway.UnsupportedContent();
            };

            /**
             * Creates a plain object from an UnsupportedContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {imminer.msggateway.UnsupportedContent} message UnsupportedContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UnsupportedContent.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UnsupportedContent to JSON.
             * @function toJSON
             * @memberof imminer.msggateway.UnsupportedContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UnsupportedContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for UnsupportedContent
             * @function getTypeUrl
             * @memberof imminer.msggateway.UnsupportedContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            UnsupportedContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/imminer.msggateway.UnsupportedContent";
            };

            return UnsupportedContent;
        })();

        return msggateway;
    })();

    return imminer;
})();

export { $root as default };
